class Audience {
  static generateId() {
    return Math.random().toString(36).substr(2, 15)
  }
}

export default Audience
